/**
 * Abbreviates large numbers for axis ticks (e.g. 275000000 -> "275M").
 */
export const formatCompactNumber = (value: number): string => {
  const abs = Math.abs(value);
  if (abs >= 1_000_000_000) return `${round(value / 1_000_000_000)}B`;
  if (abs >= 1_000_000) return `${round(value / 1_000_000)}M`;
  if (abs >= 1_000) return `${round(value / 1_000)}K`;
  return `${round(value)}`;
};

const round = (value: number) => Math.round(value * 10) / 10;
